import { walletActionTypes } from "./wallet.actionTypes";
import { Network } from "../../../utils/network";

export const getWalletTransactions =
  ({ page, limit, oldest }) =>
  async (dispatch, state) => {
    try {
      dispatch({
        type: walletActionTypes.WALLET_TRANSACTION_LOAD,
      });
      let res;
      if (page === 1) {
        res = await Network.getWalletTransactions({ limit });
      } else {
        res = await Network.getWalletTransactions({ limit, oldest });
      }
      if (res?.data) {
        res.data.page = page;
        // use selector se trasactions states
        //let all = new Set([...allTransaction, ...response.data.results]);
        dispatch({
          type: walletActionTypes.WALLET_TRANSACTION_SUCCESS,
          payload: res.data,
        });
      }
    } catch (e) {
      dispatch({
        type: walletActionTypes.WALLET_TRANSACTION_ERROR,
        payload: e.response,
      });
    }
  };

export const getConversionData = (data) => async (dispatch, state) => {
  try {
    dispatch({
      type: walletActionTypes.CONVERSION_RATE_LOAD,
    });
    let res;
    res = await Network.getExchangeRate(data);
    if (res?.data) {
      dispatch({
        type: walletActionTypes.CONVERSION_RATE_SUCCESS,
        payload: res.data,
      });
    }
  } catch (e) {
    dispatch({
      type: walletActionTypes.CONVERSION_RATE_ERROR,
      payload: e.response,
    });
  }
};

export const setDepositGSTData = (data) => async (dispatch, state) => {
  dispatch({
    type: walletActionTypes.SET_DEPOSIT_GST,
    payload: data,
  });
};
